module.exports = __webpack_public_path__ + "img/online market.c64d8ea0.png";